import { FaImage, FaRegFileWord } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa6";
import { baseurl } from "../../functions/api";
import { useStore } from "../StateProvider";

const Attachement = ({
  className = { field: "", lable: "", input: "" },
  name = "",
  label = "",
  fileurl,
  doubleline = false,
  readonly = false,
  showImageOnly = false,
  onclick = () => {},
}) => {
  const store = useStore();
  let props = store.getprops(name) || {};

  // Helper to trigger file download
  const downloadFile = (fileKey) => {
    const url = `${baseurl}/files/preview?key=${encodeURIComponent(fileKey)}`;
    const link = document.createElement("a");
    link.href = url;
    link.download = fileKey.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!props.hidden && store.getvalue(name) !== undefined) {
    if (showImageOnly && fileurl) {
      return (
        <img
          src={`${baseurl}/files/preview?key=${fileurl}`}
          alt="Company Logo"
          className={className || "rounded-full object-cover"}
        />
      );
    }

    const rawValue = fileurl || store.getvalue(name);
    const value = typeof rawValue === "string" ? rawValue : "";

    const isDocFile = value.endsWith(".docx") || value.endsWith(".doc");
    const isPdf = value.endsWith(".pdf");
    const isImage = value && !isPdf && !isDocFile;

    return (
      <div
        className={
          (className.field === ""
            ? "flex text-[5px] md:text-[14px] mb-8 ml-2 md:mb-0 w-10 h-1 px-0 py-0 md:py-0 md:w-full md:h-full md:px-3 "
            : className.field) +
          (doubleline ? "flex-col gap-1" : "flex-row items-center gap-1 md:gap-3")
        }
      >
        <button
          className={
            className.input === ""
              ? "w-full rounded-md font-medium flex justify-start items-center gap-1 md:gap-4 px-4 py-2 border-b hover:bg-Alice_Blue"
              : className.input
          }
          id={name}
          disabled={readonly}
          onClick={() => {
            if (isDocFile) {
              downloadFile(value);
            } else {
              onclick(value);
              store.setvalue("viewAttachement", value);
              store.setvalue("viewAttachementname", name);
            }
          }}
        >
          {isDocFile ? (
            <FaRegFileWord className="h-8 w-12 text-[#2b579a]" />
          ) : isPdf ? (
            <FaFilePdf className="h-8 w-12 text-[#e83b3b]" />
          ) : (
            <FaImage className="h-8 w-8 text-[#443be8]" />
          )}

          <div className="max-w-full overflow-hidden">
            {value ? value.split("/").pop() : "No file URL"}
          </div>
        </button>

        {/* Preview Viewer */}
        {store.getvalue("viewAttachement") &&
          store.getvalue("viewAttachementname") === name &&
          store.getvalue("viewAttachement") !== "" &&
          !store.getvalue("viewAttachement").endsWith(".docx") &&
          !store.getvalue("viewAttachement").endsWith(".doc") && (
            <div className="absolute top-0 left-0 h-full w-full z-50">
              <button
                onClick={() => {
                  store.setvalue("viewAttachement", "");
                }}
                className="text-[8px] md:text-[20px] px-2 py-1 md:px-6 md:py-3 rounded-full absolute right-2 md:right-5 top-3 md:top-10 bg-primary text-secondary"
              >
                X
              </button>

              {store.getvalue("viewAttachement")?.includes("pdf") ? (
                <iframe
                  className="h-[98%] w-full bg-tertiary"
                  src={`${baseurl}/files/preview?key=${encodeURIComponent(
                    store.getvalue("viewAttachement")
                  )}`}
                />
              ) : (
                <img
                  className="h-[98%] bg-tertiary"
                  src={`${baseurl}/files/preview?key=${encodeURIComponent(
                    store.getvalue("viewAttachement")
                  )}`}
                />
              )}
            </div>
          )}
      </div>
    );
  }

  return null;
};

export default Attachement;
